import BookShow from "components/shared/book/show";
import { viewContainer } from "helpers/redux";
import React from "react";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class ShowPoint extends BookShow {
    get dropdActions() {
        const actions = [];
        const { canEditBooks } = this.props;
        if (canEditBooks) {
            actions.push({ text: "Удалить", action: this.actionClose });
        }
        return actions;
    }

    renderBody = () => {
        const { config } = this.props;
        return (
            <Markup
                {...config}
                renderField={this.renderField}
                Button={this.renderButton}
                renderCheckbox={this.renderCheckbox}
            />
        );
    };
}

const ConfiguredShow = (props) => <ShowPoint {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "custompoints");
